import { subDays } from "date-fns";
import * as Yup from "yup";
import "yup-phone";

const signInSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Required"),
  password: Yup.string()
    .min(12, "Too Short! - should be 12 chars minimum.")
    .matches(/[A-Z]/, "Password must contain 1 uppercase letter.")
    .matches(/[a-z]/, "Password must contain 1 lowercase letter.")
    .matches(/[0-9]/, "Password must contain a number.")
    .matches(/[^a-zA-Z0-9]/, "Password must contain non alphanumeric.")
    .required("Required"),
  // passwordConfirmation: Yup.string().oneOf(
  //   [Yup.ref("password"), undefined],
  //   "Passwords must match"
  // ),
});
const signUpSchema = Yup.object().shape({
  fullName: Yup.string()
    .required("Required")
    .min(6, "Too Short! - should be 6 chars minimum."),
  username: Yup.string()
    .required("Required")
    .matches(/^(.*)?\S+(.*)?$/, "No space allowed")
    .trim("No space allowed")
    .min(8, "Too Short! - should be 8 chars minimum."),
  email: Yup.string().email("Invalid email").required("Required"),
  countryName: Yup.string().required("Required"),
  companyName: Yup.string().required("Required"),
  city: Yup.string().required("Required"),
  zipCode: Yup.string().required("Required"),
  street: Yup.string().required("Required"),
  // vatNumber: Yup.string().required("Required"),
  isTermAndConditionAccepted: Yup.boolean().oneOf([true], "Must be accepted"),
});

const signUpTestSchema = Yup.object().shape({
  fullName: Yup.string()
    .required("Required")
    .min(6, "Too Short! - should be 6 chars minimum."),
  username: Yup.string()
    .required("Required")
    .matches(/^(.*)?\S+(.*)?$/, "No space allowed")
    .trim("No space allowed")
    .min(8, "Too Short! - should be 8 chars minimum."),
  email: Yup.string().email("Invalid email").required("Required"),
  token: Yup.string().min(60, "invalid token").required("Required"),
  countryName: Yup.string().required("Required"),
  companyName: Yup.string().required("Required"),
  city: Yup.string().required("Required"),
  zipCode: Yup.string().required("Required"),
  street: Yup.string().required("Required"),
  vatNumber: Yup.string().required("Required"),
  isTermAndConditionAccepted: Yup.boolean().oneOf([true], "Must be accepted"),
});


const refferalSignUpSchema = Yup.object().shape({
  fullName: Yup.string()
    .required("Required")
    .min(6, "Too Short! - should be 3 chars minimum."),
  password: Yup.string()
    .min(12, "Too Short! - should be 12 chars minimum.")
    .max(20, "Too long! - should be less than 21 characters")
    .matches(/[A-Z]/, "Password must contain 1 uppercase letter.")
    .matches(/[a-z]/, "Password must contain 1 lowercase letter.")
    .matches(/[0-9]/, "Password must contain a number.")
    .matches(/[^a-zA-Z0-9]/, "Password must contain non alphanumeric.")
    .required("Required"),
  isTermAndConditionAccepted: Yup.boolean().oneOf([true], "Must be accepted"),
  confirmPassword: Yup.string().oneOf(
    [Yup.ref("password"), undefined],
    "Passwords must match",
  ),
});

const fullRefferalSignUpSchema = Yup.object().shape({
  fullName: Yup.string()
    .required("Required")
    .min(3, "Too Short! - should be 3 chars minimum."),
  password: Yup.string()
    .min(12, "Too Short! - should be 8 chars minimum.")
    .max(20, "Too long! - should be less than 21 chars")
    .matches(/[A-Z]/, "Password must contain 1 uppercase letter.")
    .matches(/[a-z]/, "Password must contain 1 lowercase letter.")
    .matches(/[0-9]/, "Password must contain a number.")
    .matches(/[^a-zA-Z0-9]/, "Password must contain non alphanumeric.")
    .required("Required"),
  isTermAndConditionAccepted: Yup.boolean().oneOf([true], "Must be accepted"),
  email: Yup.string().email("Invalid email").required("Required"),
  token: Yup.string().min(60, "invalid token").required("Required"),
});

const adminNewPartnerSchema = Yup.object().shape({
  name: Yup.string()
    .required("Required")
    .matches(/^(.*)?\S+(.*)?$/, "No space allowed")
    .min(8, "Too Short! - should be 8 chars minimum."),
  email: Yup.string().email("Invalid email").required("Required"),
});

const forgetPasswordSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Required"),
});
const resetPasswordSchema = Yup.object().shape({
  newPassword: Yup.string()
    .min(12, "Too Short! - should be 12 chars minimum.")
    .max(20, "Too long! - should be less than 21 chars")
    .matches(/[A-Z]/, "Password must contain 1 uppercase letter.")
    .matches(/[a-z]/, "Password must contain 1 lowercase letter.")
    .matches(/[0-9]/, "Password must contain a number.")
    .matches(/[^a-zA-Z0-9]/, "Password must contain non alphanumeric.")
    .required("Required"),
  confirmPassword: Yup.string().oneOf(
    [Yup.ref("newPassword"), undefined],
    "Passwords must match"
  ),
});

const updatePasswordSchema = Yup.object().shape({
  currentPassword: Yup.string()
    .min(12, "Too Short! - should be 12 chars minimum.")
    .max(20, "Too long! - should be less than 21 chars")
    .matches(/[A-Z]/, "Password must contain 1 uppercase letter.")
    .matches(/[a-z]/, "Password must contain 1 lowercase letter.")
    .matches(/[0-9]/, "Password must contain a number.")
    .matches(/[^a-zA-Z0-9]/, "Password must contain non alphanumeric.")
    .required("Required"),
  newPassword: Yup.string()
    .min(12, "Too Short! - should be 12 chars minimum.")
    .max(20, "Too long! - should be less than 21 chars")
    .matches(/[A-Z]/, "Password must contain 1 uppercase letter.")
    .matches(/[a-z]/, "Password must contain 1 lowercase letter.")
    .matches(/[0-9]/, "Password must contain a number.")
    .matches(/[^a-zA-Z0-9]/, "Password must contain non alphanumeric.")
    .required("Required"),
  confirmPassword: Yup.string().oneOf(
    [Yup.ref("newPassword"), undefined],
    "Passwords must match"
  ),
});

const userProfileSchema = Yup.object().shape({
  titleId: Yup.string()
    .required("Required"),
  gender: Yup.string().required("Required"),
  //birthday description,titileId, Lar lng 
  location: Yup.object().shape({
    latitude: Yup.string().required("Required"),
    longitude: Yup.string().required("Required"),
  }),
  birthday: Yup.date().required("Required"),
  description: Yup.string().required("Required"),
})
const changeEmailSchema = Yup.object().shape({
  currentEmail: Yup.string().email("Invalid email").required("Required"),
  newEmail: Yup.string().email("Invalid email").required("Required"),
});

const playerProfileSchema = Yup.object().shape({
  firstname: Yup.string()
    .required("Required")
    .min(3, "Too Short! - should be 3 chars minimum."),
  lastname: Yup.string()
    .required("Required")
    .min(3, "Too Short! - should be 3 chars minimum."),
  bio: Yup.string().nullable()
    .max(100, "Too big! - maximum 100 character allowed."),
});


const customerCollectionSchema = Yup.object().shape({
  contactInfo: Yup.object().shape({
    email: Yup.string().email("Invalid email").required("Required"),
    companyName: Yup.string()
      .required("Required").max(30, "Too big! - maximum 30 character allowed."),
    address: Yup.string()
      .required("Required").max(30, "Too big! - maximum 30 character allowed."),
    address1: Yup.string().max(30, "Too big! - maximum 30 character allowed."),
    postCode: Yup.string()
      .required("Required").max(30, "Too big! - maximum 30 character allowed."),
    city: Yup.string()
      .required("Required").max(30, "Too big! - maximum 30 character allowed."),
    country: Yup.string()
      .required("Required"),
    localContactName: Yup.string()
      .required("Required").max(30, "Too big! - maximum 30 character allowed."),
    countryDialCode: Yup.string()
      .required("Required").max(30, "Too big! - maximum 30 character allowed."),
    telephoneNumber: Yup.string()
      .required("Required")
      .matches(/^[0-9]+$/, "Must be only digits")
      .min(5, "Minimum 5 digit required")
      .max(30, "Too big! - maximum 30 character allowed."),
    mobileNumber: Yup.string()
      .matches(/^[0-9]+$/, "Must be only digits")
      .min(5, "Minimum 5 digit required")
      .max(30, "Too big! - maximum 30 character allowed."),
  }),
  cgiRefNumber: Yup.string().max(30, "Too big! - maximum 30 character allowed."),
  isBiosPassword: Yup.bool(),
  biosPassword: Yup.string().when("isBiosPassword", {
    is: true,
    then: Yup.string().required('Required').min(2, "Minimum 2 charaters required")
  }),
  isHddPassword: Yup.bool(),
  hddPassword: Yup.string().when("isHddPassword", {
    is: true,
    then: Yup.string().required('Required').min(2, "Minimum 2 charaters required")
  }),
  isMasterPassword: Yup.bool(),
  masterPassword: Yup.string().when("isMasterPassword", {
    is: true,
    then: Yup.string().required('Required').min(2, "Minimum 2 charaters required")
  }),
  isMdmComputracePassword: Yup.bool(),
  mdmComputracePassword: Yup.string().when("isMdmComputracePassword", {
    is: true,
    then: Yup.string().required('Required').min(2, "Minimum 2 charaters required")
  }),
  isAutopilotPassword: Yup.bool(),
  autopilotPassword: Yup.string().when("isAutopilotPassword", {
    is: true,
    then: Yup.string().required('Required').min(2, "Minimum 2 charaters required")
  }),
  additionalPackingMaterial: Yup.bool(),
  additionalPackingMaterialText: Yup.string().when("additionalPackingMaterial", {
    is: true,
    then: Yup.string().required('Required').min(2, "Minimum 2 charaters required")
  }),
  collectionDate: Yup.date()
    .nullable()
    .transform((curr, orig) => orig === '' ? null : curr)
    .required("Required").min(subDays(new Date(), 0)),
  // .max(new Date(), "Are you a time traveler?!"),
  collectionHourFrom: Yup.number().required('Required')
    .min(8, "Value must be greater than or equal to 8")
    .test('collectionHourFrom', 'invalid value', (value, context) => {
      return value !== undefined && context.parent.collectionHourTo >= value
    }),
  collectionHourTo: Yup.number().required('Required').min(8, "Value must be greater than or equal to 8")
    .test('collectionHourTo', 'invalid value', (value, context) => {
      return value !== undefined && context.parent.collectionHourFrom <= value
    }),
  collectionFrom: Yup.string()
    .required("Required"),
  weeeConfirmation: Yup.bool().required().isTrue("Must check this field"),
  // securityCageBox: Yup.bool(),
  // securityCageBoxOption: Yup.string().when("securityCageBox", {
  //   is: true,
  //   then: Yup.string().required('required')
  // }),
  // singleBox: Yup.bool(),
  // singleBoxQty: Yup.number().when("singleBox", {
  //   is: true,
  //   then: Yup.number().required('required')
  //     .typeError("Value must be a number").min(1, "Value must be greater than 0")
  // }),

});

const contactInfoSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Required"),
  companyName: Yup.string()
    .required("Required"),
  address: Yup.string()
    .required("Required"),
  postCode: Yup.string()
    .required("Required"),
  city: Yup.string()
    .required("Required"),
  country: Yup.string()
    .required("Required"),
  localContactName: Yup.string()
    .required("Required"),
  countryDialCode: Yup.string()
    .required("Required"),
  telephoneNumber: Yup.string()
    .required("Required")
    .matches(/^[0-9]+$/, "Must be only digits")
    .min(5, "Minimum 5 digit required")
    .max(30, "Too big! - maximum 30 character allowed."),
  // mobileNumber: Yup.string()
  //   .matches(/^[0-9]+$/, "Must be only digits")
  //   // .min(5, "Minimum 5 digit required")
  //   .max(30, "Too big! - maximum 30 character allowed.")
});

const customerCollectionProdcutInfoSchema = Yup.object().shape({
  isBiosPassword: Yup.bool(),
  biosPassword: Yup.string().when("isBiosPassword", {
    is: true,
    then: Yup.string().required('Required').min(2, "Minimum 2 charaters required")
  }),
  isHddPassword: Yup.bool(),
  hddPassword: Yup.string().when("isHddPassword", {
    is: true,
    then: Yup.string().required('Required').min(2, "Minimum 2 charaters required")
  }),
  isMasterPassword: Yup.bool(),
  masterPassword: Yup.string().when("isMasterPassword", {
    is: true,
    then: Yup.string().required('Required').min(2, "Minimum 2 charaters required")
  }),
  isMdmComputracePassword: Yup.bool(),
  mdmComputracePassword: Yup.string().when("isMdmComputracePassword", {
    is: true,
    then: Yup.string().required('Required').min(2, "Minimum 2 charaters required")
  }),
  isAutopilotPassword: Yup.bool(),
  autopilotPassword: Yup.string().when("isAutopilotPassword", {
    is: true,
    then: Yup.string().required('Required').min(2, "Minimum 2 charaters required")
  }),
  additionalPackingMaterial: Yup.bool(),
  additionalPackingMaterialText: Yup.string().when("additionalPackingMaterial", {
    is: true,
    then: Yup.string().required('Required').min(2, "Minimum 2 charaters required")
  }),
});

const customerCollectionStep1Schema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Required"),
  companyName: Yup.string()
    .required("Required"),
  address: Yup.string()
    .required("Required"),
  postCode: Yup.string()
    .required("Required"),
  city: Yup.string()
    .required("Required"),
  country: Yup.string()
    .required("Required"),
  localContactName: Yup.string()
    .required("Required"),
  countryDialCode: Yup.string()
    .required("Required"),
  telephoneNumber: Yup.string()
    .required("Required")
    .matches(/^[0-9]+$/, "Must be only digits")
    .min(5, "Minimum 5 digit required")
    .max(30, "Too big! - maximum 30 character allowed."),
  mobileNumber: Yup.string()
    .matches(/^[0-9]+$/, "Must be only digits")
    .min(5, "Minimum 5 digit required")
    .max(30, "Too big! - maximum 30 character allowed.")
});

const customerCollectionStep2Schema = Yup.object().shape({
  collectionDate: Yup.date()
    .nullable()
    .transform((curr, orig) => orig === '' ? null : curr)
    .required("Required").min(subDays(new Date(), 0)),
  // .max(new Date(), "Are you a time traveler?!"),
  collectionHourFrom: Yup.number().required().min(8)
    .test('collectionHourFrom', 'invalid value', (value, context) => {
      return value !== undefined && context.parent.collectionHourTo >= value
    }),
  collectionHourTo: Yup.number().required().min(8),
  // .test('collectionHourTo', 'invalid value 1', (value, context) => {
  //   return value !== undefined && context.parent.collectionHourFrom <= value
  // }),
  collectionFrom: Yup.string()
    .required(),
});

const customerCollectionStep4Schema = Yup.object().shape({
  laptop: Yup.number()
    .required()
    .min(0),
  desktop: Yup.number()
    .required()
    .min(0),
  server: Yup.number()
    .required()
    .min(0),
  monitorTft: Yup.number()
    .required()
    .min(0),
  dockStationPort: Yup.number()
    .required()
    .min(0),
  hdd: Yup.number()
    .required()
    .min(0),
  smartPhoneTablet: Yup.number()
    .required()
    .min(0),
  officePrinter: Yup.number()
    .required()
    .min(0),
  mfpPrinter: Yup.number()
    .required()
    .min(0),
  mice: Yup.number()
    .required()
    .min(0),
  keyboard: Yup.number()
    .required()
    .min(0),
  cable: Yup.number()
    .required()
    .min(0),
  network: Yup.number()
    .required()
    .min(0),
});

const adminCollectionKoUpdateSchema = Yup.object().shape({
  koId: Yup.string()
    .required("Required"),
  koNumber: Yup.string()
    .required("Required")
    .min(11, "Too Short! - should be 11 chars minimum."),
});


const validateCcEmails = Yup.object().shape({
  ccEmail: Yup.array().of(Yup.string().email())
});

const customerCollectionProductInfo = Yup.object().shape({
  productType: Yup.string().required(),
  quantity: Yup.number()
    .typeError("Value must be a number")
    .required("Required")
    .min(1, "Value must be greater than 0"),
});

const tempRegisterUserSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Required"),
  actionName: Yup.string().required(),
});

const tempRegisterUserReferalSchema = Yup.object().shape({
  // fullName: Yup.string()
  //   .required("Required")
  //   .min(3, "Too Short! - should be 3 chars minimum."),
  password: Yup.string()
    .min(12, "Too Short! - should be 12 chars minimum.")
    .max(20, "Too long! - should be less than 21 chars")
    .matches(/[A-Z]/, "Password must contain 1 uppercase letter.")
    .matches(/[a-z]/, "Password must contain 1 lowercase letter.")
    .matches(/[0-9]/, "Password must contain a number.")
    .matches(/[^a-zA-Z0-9]/, "Password must contain non alphanumeric.")
    .required("Required"),
  isTermAndConditionAccepted: Yup.boolean().oneOf([true], "Must be accepted"),
  confirmPassword: Yup.string().oneOf(
    [Yup.ref("password"), undefined],
    "Passwords must match",
  ),
});

const fullTempRegisterUserReferalSchema = Yup.object().shape({
  // fullName: Yup.string()
  //   .required("Required")
  //   .min(3, "Too Short! - should be 3 chars minimum."),
  password: Yup.string()
    .min(12, "Too Short! - should be 12 chars minimum.")
    .max(20, "Too long! - should be less than 21 chars")
    .matches(/[A-Z]/, "Password must contain 1 uppercase letter.")
    .matches(/[a-z]/, "Password must contain 1 lowercase letter.")
    .matches(/[0-9]/, "Password must contain a number.")
    .matches(/[^a-zA-Z0-9]/, "Password must contain non alphanumeric.")
    .required("Required"),
  isTermAndConditionAccepted: Yup.boolean().oneOf([true], "Must be accepted"),
  email: Yup.string().email("Invalid email").required("Required"),
  token: Yup.string().min(60, "invalid token").required("Required"),
});

export {
  signInSchema,
  signUpSchema,
  forgetPasswordSchema,
  resetPasswordSchema,
  userProfileSchema,
  changeEmailSchema,
  playerProfileSchema,
  updatePasswordSchema,
  customerCollectionSchema,
  customerCollectionStep1Schema,
  customerCollectionStep2Schema,
  customerCollectionStep4Schema,
  customerCollectionProdcutInfoSchema,
  adminCollectionKoUpdateSchema,
  validateCcEmails,
  customerCollectionProductInfo,
  contactInfoSchema,
  adminNewPartnerSchema,
  refferalSignUpSchema,
  fullRefferalSignUpSchema,
  signUpTestSchema,
  tempRegisterUserSchema,
  tempRegisterUserReferalSchema,
  fullTempRegisterUserReferalSchema
};